export default "__VITE_ASSET__BIWm9_ih__"